<template>
    <div class="cell-content">
        <span class="merge-status" :class="statusClass">{{ statusLabel }}</span>
    </div>
</template>

<script>
import Cell from './cell';

export default {
    mixins: [ Cell ],

    computed: {
        statusClass() {
            switch (this.value) {
                case 'welcome':
                    return 'is-welcome';
                case 'buspaket':
                    return 'is-buspaket';
                case 'merged':
                case null:
                case undefined:
                    return 'is-merged';
                default:
                    return '';
            }
        },

        statusLabel() {
            switch (this.value) {
                case 'welcome':
                    return 'W';
                case 'buspaket':
                    return 'B';
                case 'merged':
                case null:
                case undefined:
                    return '';
                default:
                    return '-';
            }
        }
    }
}
</script>

